"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resources = exports.Levels = exports.Roles = exports.Actions = exports.doesClaimAllowOn = exports.doesClaimAllow = exports.isAllowedOn = exports.isAllowed = void 0;
const isAllowed_1 = require("../src/functions/isAllowed");
Object.defineProperty(exports, "isAllowed", { enumerable: true, get: function () { return isAllowed_1.isAllowed; } });
const isAllowedOn_1 = require("../src/functions/isAllowedOn");
Object.defineProperty(exports, "isAllowedOn", { enumerable: true, get: function () { return isAllowedOn_1.isAllowedOn; } });
const doesClaimAllow_1 = require("../src/functions/doesClaimAllow");
Object.defineProperty(exports, "doesClaimAllow", { enumerable: true, get: function () { return doesClaimAllow_1.doesClaimAllow; } });
const doesClaimAllowOn_1 = require("../src/functions/doesClaimAllowOn");
Object.defineProperty(exports, "doesClaimAllowOn", { enumerable: true, get: function () { return doesClaimAllowOn_1.doesClaimAllowOn; } });
const enum_actions_1 = require("../types/enum.actions");
Object.defineProperty(exports, "Actions", { enumerable: true, get: function () { return enum_actions_1.Actions; } });
const type_claim_1 = require("../types/type.claim");
Object.defineProperty(exports, "Roles", { enumerable: true, get: function () { return type_claim_1.Roles; } });
Object.defineProperty(exports, "Levels", { enumerable: true, get: function () { return type_claim_1.Levels; } });
const type_resource_1 = require("../types/type.resource");
Object.defineProperty(exports, "Resources", { enumerable: true, get: function () { return type_resource_1.Resources; } });
// Export everything
__exportStar(require("../types/enum.actions"), exports);
__exportStar(require("../types/enum.entitlements"), exports);
__exportStar(require("../types/enum.sources"), exports);
__exportStar(require("../types/enum.tokentypes"), exports);
__exportStar(require("../types/type.claim"), exports);
__exportStar(require("../types/type.permission"), exports);
__exportStar(require("../types/type.policy"), exports);
__exportStar(require("../types/type.resource"), exports);
__exportStar(require("../types/type.record"), exports);
